import { Heading } from 'components/Typography/General';
import { useRouter } from 'next/router';
import React, { useCallback, useMemo } from 'react';
import generateBreadcrumbCategory from 'utils/generate_breadcrumb_name';

const TitleSection = ({ categoryName }) => {
  const router = useRouter();

  const isRouterIncludes = useCallback((string) => router.asPath.includes(string), [router.asPath]);
  let breadcrumbCategory = categoryName?.replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase()).replace('+LMS', ' ').replace('Lerero & ', 'Lerero') || categoryName;
  const titles = useMemo(
    () => [
      {
        isDisplayed: isRouterIncludes('?category=all'),
        text: 'All Categories',
      },
      {
        isDisplayed: isRouterIncludes('?courses=all'),
        text: 'All Courses',
      },
      {
        isDisplayed: isRouterIncludes('category?provider=all'),
        text: 'All Providers',
      },
      {
        isDisplayed: isRouterIncludes('category?products=all'),
        text: 'All Products',
      },
      {
        isDisplayed: isRouterIncludes('category?bundles=all'),
        text: 'All Bundles',
      },
      {
        isDisplayed: isRouterIncludes('category?search='),
        text: 'Search Result',
      },
      {
        isDisplayed: breadcrumbCategory !== 'All',
        text: generateBreadcrumbCategory(
          breadcrumbCategory === 'nutricition diet' || breadcrumbCategory === 'parenting relationship'
            ? breadcrumbCategory.replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase()).replace(' ', ' & ').replace('+', ' ')
            : breadcrumbCategory
        ),
      },
    ],
    [categoryName, isRouterIncludes]
  );

  return (
    <>
      <Heading variety={2} className="d-none d-lg-inline-block text-capitalize">
        {titles && titles?.find((title) => title?.isDisplayed)?.text || 'All Categories'}
      </Heading>
    </>
  );
};

export default TitleSection;
